import { InteractionType } from '@azure/msal-browser'
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsalAuthentication } from '@azure/msal-react'
import { META_ICONS_CDN_BASE_URL, META_ICONS_MANIFEST } from '@porsche-design-system/assets'
import React from 'react'

import { useFavicon } from './shared/utils/useFavicon'
import Authentication from './views/Authentication/Authentication'
import Portal from './views/Portal'

import { SCOPE_API } from './shared/config/config'

const App = () => {
  const { error, login } = useMsalAuthentication(InteractionType.Silent, {
    scopes: [SCOPE_API]
  })

  useFavicon(`${META_ICONS_CDN_BASE_URL}/${META_ICONS_MANIFEST.favicon.favicon_32x32}`)
  React.useEffect(() => {
    if (error) {
      login(InteractionType.Popup, {
        scopes: [SCOPE_API]
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <AuthenticatedTemplate>
        <Portal />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Authentication />
      </UnauthenticatedTemplate>
    </React.Fragment>
  )
}

export default App
